"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolGroupAlreadyExistsError extends client_library_1.ExtendableError {
    constructor(reason) {
        super(reason);
        this.reason = reason;
    }
}
exports.default = SchoolGroupAlreadyExistsError;
//# sourceMappingURL=SchoolGroupAlreadyExistsError.js.map